import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { ProfileStatItemProps } from './types';

export const ProfileStatItem = ({ value, label, onClick }: ProfileStatItemProps) => (
    <Flex
        direction="row"
        spacing={0.5}
        onClick={onClick}
        cursor={onClick ? 'pointer' : 'default'}
        role={onClick ? 'button' : undefined}
    >
        <Typography variant="body2" weight="medium">
            {value}
        </Typography>
        <Typography variant="body2" weight="medium">
            {label}
        </Typography>
    </Flex>
);
